import { useSelector } from "react-redux";

import { IsVisible } from "../components/types";
import { RootState } from "../store/rootReducer";

export const useGetFormVisibility = (
  visibilitySelector?: IsVisible,
  sectionId = ""
): boolean =>
  useSelector((state: RootState) => {
    if (!visibilitySelector) {
      return true;
    }

    return visibilitySelector(state, sectionId);
  });
